import React from 'react';
import { Cpu, Cog, Box, Layers, ScanLine, ShieldCheck, Workflow } from 'lucide-react';
import fallbackBanner from '../assets/stores/robu.jpg';
import './ManufacturingShowcase.css';

function loadBannerImage() {
  try {
    const ctx = require.context('../assets/banner', false, /\.(png|jpe?g|webp|gif)$/i);
    const keys = ctx.keys();
    if (keys.length) return ctx(keys[0]);
  } catch {
    // no banner folder/image yet
  }
  return fallbackBanner;
}

const topFeatures = [
  {
    icon: Cpu,
    title: 'Accurate Part Matching',
    text: 'Find exact modules and ICs with verified naming and practical alternatives.',
  },
  {
    icon: Cog,
    title: 'Smart BOM Generation',
    text: 'Convert project ideas into actionable BOMs with quantity and store context.',
  },
  {
    icon: Box,
    title: 'Multi-Store Sourcing',
    text: 'Compare Indian stores side-by-side with quick links and datasheet access.',
  },
];

const offerCards = [
  {
    icon: Layers,
    title: 'Project to BOM',
    text: 'Generate real component lists from plain project descriptions.',
    featured: true,
  },
  {
    icon: ScanLine,
    title: 'BOM File Parsing',
    text: 'Upload CSV/TXT BOMs and normalize part names and quantities automatically.',
  },
  {
    icon: Workflow,
    title: 'Store-Wise Carting',
    text: 'Build a universal cart and select lowest-price store per component.',
  },
  {
    icon: ShieldCheck,
    title: 'Datasheet Safety',
    text: 'Every part includes datasheet lookup support for validation before purchase.',
  },
];

export default function ManufacturingShowcase() {
  const bannerImage = loadBannerImage();

  return (
    <section className="mfg-showcase" aria-label="HardwareGenie capabilities">
      <div className="mfg-hero" style={{ backgroundImage: `url(${bannerImage})` }}>
        <div className="mfg-overlay" />
        <div className="mfg-content">
          <h2>
            BRING IDEAS TO LIFE
            <br />
            WITH PRECISION PART
            <br />
            SOURCING
          </h2>
          <p>
            Design, validate, and source electronics faster with intelligent BOM generation
            and real store-linked components.
          </p>
          <div className="mfg-actions">
            <a href="#categories-anchor" className="mfg-btn mfg-btn-primary">Explore Categories</a>
            <a href="#how" className="mfg-btn mfg-btn-secondary">See Workflow</a>
          </div>
        </div>
      </div>

      <div className="mfg-feature-row">
        {topFeatures.map((item) => {
          const Icon = item.icon;
          return (
            <article key={item.title} className="mfg-feature-card">
              <div className="mfg-feature-icon"><Icon size={22} /></div>
              <div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </article>
          );
        })}
      </div>

      <div className="mfg-offer-head">
        <span>WHAT WE OFFER</span>
        <h3>SHAPING FASTER HARDWARE BUILD FLOWS</h3>
      </div>

      <div className="mfg-offer-grid">
        {offerCards.map((card) => {
          const Icon = card.icon;
          return (
            <article key={card.title} className={`mfg-offer-card ${card.featured ? 'featured' : ''}`}>
              <div className="mfg-offer-icon"><Icon size={18} /></div>
              <h4>{card.title}</h4>
              <p>{card.text}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}
